/**
 * Les erreurs du schéma `compta`, dites en clair.
 *
 * Tant que `compta` n'est pas dans les « Exposed schemas » du projet
 * Supabase, PostgREST refuse toute requête avec `PGRST106` et un message
 * technique (« The schema must be one of the following: public,
 * graphql_public »). Ce n'est pas une panne mais un réglage à faire une fois ;
 * l'écran le dit ainsi.
 */

import { messageErreur } from '../../payments/erreur';

export const SCHEMA_NON_EXPOSE =
  'Le schéma « compta » n’est pas encore exposé à l’API. Dans Supabase : Project Settings → API → Exposed schemas, ajouter « compta », puis recharger la page.';

/**
 * Une vue ou une table que l'API ne connaît pas (`PGRST205`) : la migration
 * qui la crée n'est pas encore appliquée à cette base, ou le cache de schéma
 * de l'API ne l'a pas encore vue. Ce n'est pas une panne de l'écran, et le
 * dire ainsi évite de chercher ailleurs.
 */
export function lectureAbsente(nom: string | null): string {
  return `${nom ? `« ${nom} »` : 'Cette lecture'} n’existe pas encore dans cette base : la migration qui la crée n’y est pas appliquée, ou le cache de l’API ne l’a pas encore vue.`;
}

export function enClair(e: unknown, defaut?: string): string {
  const o = (e ?? {}) as { code?: unknown; message?: unknown };
  if (o.code === 'PGRST106' || (typeof o.message === 'string' && /schema must be one of/i.test(o.message))) {
    return SCHEMA_NON_EXPOSE;
  }
  if (o.code === 'PGRST205') {
    const nom = typeof o.message === 'string' ? /'([^']+)'/.exec(o.message)?.[1] ?? null : null;
    return lectureAbsente(nom);
  }
  return messageErreur(e, defaut);
}
